import React, { useEffect, useState } from 'react';
import SoftBox from "../../../../../components/SoftBox";
import { useSoftUIController, setMiniSidenav, setOpenConfigurator } from "context";
function CoverageMap() {
    const [loading, setLoading] = useState(true);
    const [controller, dispatch] = useSoftUIController();
    const mapStyle = {
        "& div ymaps": {
            borderRadius: "16px"
        },
        '.ymaps3x0--map-copyrights_bottom': {
            display: "none"
        }
    };

    useEffect(() => {
        let isMounted = true;

        const loadMap = async () => {
            try {
                await initMap(controller, dispatch);
                if (isMounted) setLoading(false);
            } catch (error) {
                console.error("Ошибка инициализации карты", error);
            }
        };

        loadMap();

        return () => {
            isMounted = false;
        };
    }, []);

    return (
        <SoftBox style={{ height: "calc(100vh - 72px)", borderRadius: "16px", margin: "36px", boxShadow: "0px 0px 10px 7px rgba(0, 0, 0, 0.1)"}} sx={mapStyle}>
            <div id="app" style={{ width: "100%", height: "100%" }} />
        </SoftBox>
    );
}

async function initMap(controller, dispatch) {
    await window.ymaps3.ready;

    const {
        YMap,
        YMapDefaultSchemeLayer,
        YMapControls,
        YMapListener,
        YMapControlButton,
        YMapLayer,
        YMapMarker,
        YMapDefaultFeaturesLayer
    } = window.ymaps3;

    const { YMapGeolocationControl, YMapZoomControl } = await window.ymaps3.import(
        '@yandex/ymaps3-controls@0.0.1'
    );

    const { YMapOpenMapsButton } = await window.ymaps3.import(
        '@yandex/ymaps3-controls-extra'
    );

    const center = [76.945646, 43.239852];

    const map = new YMap(document.getElementById('app'), {
        location: {
            center: center,
            zoom: 16.5
        },
        behaviors: ['drag', 'scrollZoom', 'dblClick', 'mouseRotate', 'mouseTilt'],
        showScaleInCopyrights: true,
        copyrights: false,
        camera: { tilt: (60 * Math.PI) / 180 },
        customization: {
            poi: false,
        }
    });

    const controls = new YMapControls({ position: 'top left', orientation: 'vertical' });
    map.addChild(controls);

    // 🔥 Обязательный слой для маркеров и фичей
    map.addChild(new YMapDefaultFeaturesLayer());

    // 🔹 Маркеры с изображениями
    const icons = [
        '/assets/coverage-blue.svg',
        '/assets/coverage-green.svg',
        '/assets/coverage-red.svg'
    ];
    const quantity = 100;
    const radius = 0.03;

    const randomOffset = (r = 0.01) => [
        center[0] + (Math.random() - 0.5) * r,
        center[1] + (Math.random() - 0.5) * r
    ];

    const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !controller.openConfigurator);
    const createMarker = (coordinates, iconUrl) => {
        const el = document.createElement('div');
        el.style.display = 'flex';
        el.style.alignItems = 'center';
        el.style.justifyContent = 'center';
        el.style.width = '50px';
        el.style.height = '50px';

        const img = document.createElement('img');
        img.src = iconUrl;

        img.style.maxWidth = '100%';
        img.style.maxHeight = '100%';
        img.style.objectFit = 'contain';
        img.style.cursor = 'pointer';
        img.style.display = 'block';

        // отладочная рамка
        // img.style.border = '1px solid red';

        img.addEventListener('click', () => {
            return handleConfiguratorOpen();
        });

        el.appendChild(img);
        return new window.ymaps3.YMapMarker({ coordinates }, el);
    };


    for (let i = 0; i < quantity; i++) {
        const coords = randomOffset(radius);
        const iconUrl = icons[Math.floor(Math.random() * icons.length)];
        const marker = createMarker(coords, iconUrl);
        map.addChild(marker);
    }

    // Слои карты
    map.addChild(new YMapDefaultSchemeLayer({ theme: "light", visible: false, source: 'scheme' }));
    map.addChild(new YMapLayer({ zIndex: 1, source: 'scheme', type: 'ground' }));
    map.addChild(new YMapLayer({ zIndex: 12, source: 'scheme', type: 'labels' }));
    map.addChild(new YMapLayer({ zIndex: 3, source: 'scheme', type: 'buildings' }));

    // Автоповорот камеры
    let hasAutoRotate = true;
    let frame = 0;

    function onActionStartHandler() {
        hasAutoRotate = false;
        autoRotateBtn.update({ background: '#007afce6' });
    }

    const mapListener = new YMapListener({
        layer: 'any',
        onActionStart: onActionStartHandler
    });
    map.addChild(mapListener);

    const controlsBottom = new YMapControls({ position: 'bottom' });
    map.addChild(controlsBottom);

    function startAutoRotationCamera() {
        if (hasAutoRotate) {
            map.update({ camera: { azimuth: map.azimuth + (10 * Math.PI) / 180 / 120 } });
            frame = requestAnimationFrame(startAutoRotationCamera);
        } else {
            cancelAnimationFrame(frame);
        }
    }

    startAutoRotationCamera();

    function autoRotateBtnHandler() {
        hasAutoRotate = !hasAutoRotate;
        autoRotateBtn.update({ background: hasAutoRotate ? '#fd6466e6' : '#007afce6' });
        startAutoRotationCamera();
    }

    const autoRotateBtn = new YMapControlButton({
        text: 'Auto Rotate',
        color: '#fff',
        background: '#fd6466e6',
        onClick: autoRotateBtnHandler
    });

    controls.addChild(autoRotateBtn);
}

export default CoverageMap;
